import useTranslator from "@pma/hooks/use-translator"
import { Tooltip, TooltipContent, TooltipTrigger } from "../common/tooltip"
import { Button } from "../common/button"
import { Mail } from "lucide-react"
import { DictType } from "@pma/types"

interface Props {
  file: DictType
  isMenuView?: boolean
}

const ShareFileOnEmail = ({ file, isMenuView }: Props) => {
  const { translate } = useTranslator()

  const handleEmailClick = () => {
    const subject = "File Request"
    const body = encodeURIComponent(
      `Hi,\n\nPlease find the attached file: ${file.name}\n\n${file.file}`,
    )

    const link = `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=support@example.com&su=${subject}&body=${body}`
    window.open(link, "_blank")
  }

  return isMenuView ? (
    <div className='flex items-center gap-2 rounded hover:bg-muted' onClick={handleEmailClick}>
      <div className='px-2'>
        <Mail className='' size={16} />
      </div>
      <span className='text-sm'>{translate("Share on Mail")}</span>
    </div>
  ) : (
    <Tooltip>
      <TooltipTrigger>
        <Button
          size={"icon"}
          className='h-6 w-7'
          variant={"ghost"}
          aria-label={translate("Share on Mail")}
          onClick={handleEmailClick}
        >
          <Mail size={14} />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{translate("Share on Mail")}</TooltipContent>
    </Tooltip>
  )
}

export default ShareFileOnEmail
